import {
    BooleanField,
    Button,
    Confirm,
    DateField,
    EditButton,
    Identifier,
    Labeled,
    TextField,
    useNotify,
    useRecordContext,
    useRedirect
} from "react-admin"

import { Box, Card, CardContent, Paper, Typography } from "@mui/material"
import BackToListField from "CustomFields/BackToListField"
import { useState } from "react"
import { GenerateUrlByResource } from "Providers/Helpers"
import { httpClient } from "Helpers"

const ViewAside = () => {
    const record = useRecordContext()

    if (!record) return null

    const UpdateMediaCatAllowedButton = ({
        id,
        isMediaCatAllow
    }: {
        id: Identifier
        isMediaCatAllow: boolean
    }) => {
        const redirect = useRedirect()
        const notify = useNotify()
        const [isOpen, setIsOpen] = useState(false)
        const [loading, setLoading] = useState(false)

        const buttonText = isMediaCatAllow ? "Yayınlama" : "Yayınla"

        const showAreYouSure = () => {
            setIsOpen(true)
        }

        const sendReq = (message?: string | null) => {
            const baseUrl = GenerateUrlByResource("feature-category")
            httpClient(`${baseUrl}/${id}/change-media-cat-allow`, {
                method: "PUT",
                body: JSON.stringify({ message })
            })
                .then(() => {
                    notify(
                        isMediaCatAllow
                            ? "Artık Media Cat'te bu çalışma alanına bağlı freelancerlar gösterilmeyecek"
                            : "Artık Media Cat'te bu çalışma alanına bağlı freelancerlar gösterilecek"
                    )
                })
                .catch((e) => {
                    notify("Bir hata oluştu.", { type: "warning" })
                })
                .finally(() => {
                    setLoading(false)
                    setIsOpen(false)
                    window.location.reload();
                })
        }

        const handleSubmit = () => {
            setLoading(true)
            sendReq()
        }

        return (
            <>
                <Confirm
                    isOpen={isOpen}
                    title={buttonText}
                    content={
                        isMediaCatAllow
                            ? "Artık Media Cat'te bu çalışma alanına bağlı freelancerlar gösterilmeyecek, emin misiniz?"
                            : "Artık Media Cat'te bu çalışma alanına bağlı freelancerlar gösterilecek, emin misiniz?"
                    }
                    confirm="Evet"
                    confirmColor="default"
                    cancel="Vazgeç"
                    onConfirm={handleSubmit}
                    onClose={() => {
                        setIsOpen(false)
                    }}
                />
                <Button
                    label={buttonText}
                    onClick={showAreYouSure}
                    disabled={loading}
                    variant={!isMediaCatAllow ? "contained" : "outlined"}
                    color={!isMediaCatAllow ? "secondary" : "primary"}
                />
            </>
        )
    }

    return (
        <Box>
            <BackToListField source="feature-category" />
            <Paper elevation={20}>
                <Card>
                    <CardContent>
                        <Typography>
                            <TextField source="name" variant="h6" />
                        </Typography>
                        <Box
                            display="flex"
                            flexDirection="column"
                            gap={0.5}
                            mt={1}>
                            <Labeled label="Slug">
                                <TextField source="slug" />
                            </Labeled>

                            <Labeled label="MediaCat Yayınlanma Durumu">
                                <BooleanField source="isMediaCatAllowed" />
                            </Labeled>

                            <Labeled label="Oluşturma Tarihi">
                                <DateField
                                    source="createDate"
                                    label="Oluşturma Tarihi"
                                />
                            </Labeled>
                        </Box>
                    </CardContent>
                    <Box display="flex" justifyContent="center" mt={0.3} mb={1}>
                        <UpdateMediaCatAllowedButton
                            id={record.id}
                            isMediaCatAllow={record.isMediaCatAllowed}
                        />
                    </Box>
                </Card>
            </Paper>
        </Box>
    )
}

export default ViewAside
